import { Expose } from 'class-transformer';
import { Model } from '../../shared-features/models/model';
export class TrucksShipments extends Model {
    @Expose() totalCount: number;
    @Expose() totalCost: number;
    @Expose() totalPrice: number;
    @Expose() margin: number;
}
